<template>
  <div class="container">
    <template v-if="isShowSteps">
      <div class="steps">
        <div class="step" v-for="(item, index) in processList" :key="index">
          <div class="head">
            <div class="line"></div>
            <div class="icon" @click="handleDetail(item, index)">
              <span class="m-steps_icon" :style="{ background: item.bgColor }">{{ item.text }}</span>
            </div>
          </div>
          <div class="main" ref="main">
            <div class="m-steps_content" @click="handleDetail(item, index)">
              <div class="m-steps_content_info">
                <p>{{ parseTime(item.recordTime, '{y}年{m}月{d}') }}</p>
                <p>{{ getStepInfo(item) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <img src="@/assets/img/empty.png" style="width: 100px; display: block; margin: 30px auto" />
    </template>

    <Mdialog
      title="溯源信息"
      :visible.sync="dialog"
      top="50px"
      width="50%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      custom-class="trace-dialog"
      @closes="closeDialog"
    >
      <div>
        <div class="title">{{ formData.text }}</div>
        <div style="margin-bottom: 30px">
          <TablePublic :key="currentName" :paginationFlag="false" :colLists="colLists" :tableData="this.formData.map ? [this.formData.map] : []"> </TablePublic>
        </div>

        <div class="img">
          <div class="img-item" v-for="(item, index) in formData.attachList" :key="index">
            <el-image
              v-if="item.type === 2"
              style="width: 100%; max-width: 300px"
              lazy
              :src="item.url"
              :preview-src-list="formData.attachList.map((item) => item.url)"
            >
              <div slot="placeholder" class="img-item_slot">
                <span class="el-icon-loading" style="font-size: 30px"></span>
              </div>
            </el-image>
            <div>
              <video controls v-if="item.type === 3" :src="item.url" style="width: 100%; max-width: 300px">
                <source :src="item.fileUrl" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>

        <template v-if="!formData.attachList || !formData.attachList.length">
          <img src="@/assets/img/empty.png" style="width: 100px; display: block; margin: 30px auto" />
        </template>
      </div>
      <div slot="footer">
        <div class="pagination">
          <el-button class="left-button" @click="onCurrentChange('prev')" :disabled="currentPage === 1"><</el-button>
          <div class="page">{{ currentPage }}/{{ processList.length }}</div>
          <el-button
            class="right-button"
            @click="onCurrentChange('next')"
            :disabled="currentPage === processList.length"
            >></el-button
          >
        </div>
      </div>
    </Mdialog>
  </div>
</template>

<script>
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'

import { getTraceabilityNode } from '@/api/manage/report'

import { isDef } from '@/utils/is'

import { TRACE_NAME } from './const'

//溯源步骤
const traceabilityStep = {
  [TRACE_NAME.PICKING_BATCH_TASK]: { text: '采摘', bgColor: '#47b700', mapKey: 'pickMap' },
  [TRACE_NAME.SHIPPING_ORDER_ITEM]: { text: '运输', bgColor: '#4486b3', mapKey: 'shippMap' },
  [TRACE_NAME.INSPECTION_SHEET_ITEM]: { text: '鲜果验收', bgColor: '#cb921b', mapKey: 'inpectionMap' },
  [TRACE_NAME.FRESH_PEEL_PROD_REC]: { text: '生产加工', bgColor: '#4486b3', mapKey: 'freshMap' },
  [TRACE_NAME.DRY_PEEL_PROD_REC]: { text: '干皮记录', bgColor: '#cb921b', mapKey: 'dryMap' },
  [TRACE_NAME.INSPECTION_INBOUND_ORDER]: { text: '入库验收', bgColor: '#4486b3', mapKey: 'inboundMap' },
  [TRACE_NAME.PRODUCT_INBOUND_DETAIL]: { text: '产品入库', bgColor: '#cb921b', mapKey: 'productInboundMap' },
}

export default {
  name: 'TraceabilityDetail',
  components: {
    Mdialog,
    TablePublic,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      currentPage: 1,

      importHeaders: '',
      uploadPath: '',
      // colLists: [
      //   {
      //     prop: 'code',
      //     label: '培育方式',
      //     isTrue: true,
      //     formSolt: true,
      //   },
      //   {
      //     prop: 'oilCode',
      //     label: '成熟度',
      //     isTrue: true,
      //     formSolt: true,
      //   },
      //   {
      //     prop: 'createTime',
      //     label: '计划采购总净重(斤)',
      //     isTrue: true,
      //     formSolt: true,
      //   },

      //   {
      //     label: '操作',
      //     prop: 'address',
      //     align: 'center',
      //     solt: true,
      //     isTrue: true,
      //     width: 200,
      //     rightFlag: true,
      //   },
      // ],
      formData: { attachments: [] },
      tableData: [],

      processList: [],

      dialog: false,

      currentName: '',
    }
  },
  computed: {
    isShowSteps() {
      return (this.processList.length > 0 && this.processList[0].recordTime) || this.processList.length > 1
    },
    colLists() {
      const _this = this
      const colMap = {
        [TRACE_NAME.PICKING_BATCH_TASK]: [
          {
            prop: 'bizNo',
            label: '采摘批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'recordTime',
            label: '采摘日期',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.parseTime(row.recordTime, '{y}-{m}-{d}')
            },
          },
          {
            prop: 'plantationName',
            label: '果园名称',
            isTrue: true,
            minWidth: '150',
          },

          {
            prop: 'locDetails',
            label: '果园区域',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return row.locDetails?.split(',').slice(3).join('')
            },
          },
          {
            prop: 'geoposDetails',
            label: '果园定位',
            isTrue: true,
            minWidth: '150',
          },

          {
            prop: '',
            label: '巡查结果',
            isTrue: true,
            minWidth: '150',
            formatter() {
              return '达标'
            },
          },
          {
            prop: 'cropBrandKeyValue',
            label: '产品名称',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'spec',
            label: '规格',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'cropAgeValue',
            label: '果树树龄',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return (Number(row.cropAgeValue) || 0).toFixed(0)
            }
          },
          {
            prop: 'planToPickTotalQuantity',
            label: '采摘筐数',
            minWidth: '150',
            isTrue: true,
          },
          {
            prop: 'planToPickTotalNetWeight',
            label: '采摘净重（斤）',
            minWidth: '150',
            isTrue: true,
          },
          {
            prop: 'fertilizerTypeKeyValue',
            label: '施肥种类',
            minWidth: '150',
            isTrue: true,
          },
          {
            prop: 'fieldTypeKeyValueList',
            label: '土地性质',
            minWidth: '150',
            isTrue: true,
          },
          {
            prop: 'supervisorIdList',
            label: '监园人员',
            minWidth: '150',
            isTrue: true,
            formatter(row) {
              return JSON.parse(row.supervisorIdList || '[]')
                .map((item) => item.userName)
                .join(',')
            },
          },
        ],
        [TRACE_NAME.SHIPPING_ORDER_ITEM]: [
          {
            prop: 'shippingOrderBizNo',
            label: '运输单号',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'recordTime',
            label: '运输日期',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.parseTime(row.recordTime, '{y}-{m}-{d}')
            },
          },
          {
            prop: 'licensePlateNumber',
            label: '车牌号',
            isTrue: true,
            minWidth: '150',
          },

          {
            prop: 'lockNumber',
            label: '锁号',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'pickingBatchBizNo',
            label: '采摘批次',
            isTrue: true,
            minWidth: '150',
          },

          {
            prop: 'plantationName',
            label: '果园名称',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'locDetails',
            label: '果园区域',
            isTrue: true,
            minWidth: '200',
            formatter(row) {
              return row.locDetails?.split(',').slice(3).join('')
            },
          },
          {
            prop: 'geoPosDetails',
            label: '果园定位',
            isTrue: true,
            minWidth: '200',
          },
          {
            prop: 'totalQuantity',
            label: '运输筐数',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'totalNetWeight',
            label: '运输净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'driverName',
            label: '司机',
            isTrue: true,
            minWidth: '150',
          },
        ],
        [TRACE_NAME.INSPECTION_SHEET_ITEM]: [
          {
            prop: 'pickingBatchBizNo',
            label: '采摘批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'recordTime',
            label: '验收日期',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.parseTime(row.recordTime, '{y}-{m}-{d}')
            },
          },
          {
            prop: 'licensePlateNumber',
            label: '车牌号',
            isTrue: true,
            minWidth: '150',
          },

          {
            prop: 'lockNumber',
            label: '锁号',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: '',
            label: '加工厂地址',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              const loc =
                row.cnProvinceName === row.cnCityName
                  ? `${row.cnProvinceName || ''}${row.cnDistrictName || ''}`
                  : `${row.cnProvinceName || ''}${row.cnCityName || ''}${row.cnDistrictName || ''}`
              return `${loc}${row.locDetails || ''}`
            },
          },

          {
            prop: 'spec',
            label: '规格',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'totalQuantity',
            label: '果园过磅筐数',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'totalNetWeight',
            label: '果园过磅总净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'totalApprovedQuantity',
            label: '工厂核验筐数',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'totalApprovedNetWeight',
            label: '工厂核验总净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'operatorName',
            label: '验收人员',
            isTrue: true,
            minWidth: '150',
          },
        ],
        [TRACE_NAME.FRESH_PEEL_PROD_REC]: [
          {
            prop: 'pickingBatchBizNo',
            label: '采摘批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'recordTime',
            label: '加工日期',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.parseTime(row.recordTime, '{y}-{m}-{d}')
            },
          },
          {
            prop: 'processFactory',
            label: '加工厂',
            isTrue: true,
            minWidth: '150',
          },

          {
            prop: '',
            label: '加工厂地址',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              const loc =
                row.cnProvinceName === row.cnCityName
                  ? `${row.cnProvinceName || ''}${row.cnDistrictName || ''}`
                  : `${row.cnProvinceName || ''}${row.cnCityName || ''}${row.cnDistrictName || ''}`
              return `${loc}${row.locDetails || ''}`
            },
          },
          {
            prop: 'freshFruitTotalNetWeight',
            label: '鲜果总净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'freshPeelTotalNetWeight',
            label: '鲜皮总净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'peelRate',
            label: '鲜皮率（%）',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.myFixed(row.peelRate, 2)
            },
          },
          {
            prop: 'createBy',
            label: '加工人员',
            isTrue: true,
            minWidth: '150',
          },
        ],
        [TRACE_NAME.DRY_PEEL_PROD_REC]: [
          {
            prop: 'pickingBatchBizNo',
            label: '采摘批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'freshFruitTotalNetWeight',
            label: '鲜果总净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'recordTime',
            label: '干皮生产日期',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.parseTime(row.recordTime, '{y}-{m}-{d}')
            },
          },

          {
            prop: 'dryBizNo',
            label: '干皮批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'productName',
            label: '产品名称',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'specDetails',
            label: '规格',
            isTrue: true,
            minWidth: '200',
          },
          {
            prop: 'inventoryLocation',
            label: '仓库',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'storageArea',
            label: '库区',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'totalNetWeight',
            label: '干皮总净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'peelRate',
            label: '出皮率(%)',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.myFixed(row.peelRate, 2)
            },
          },
        ],
        [TRACE_NAME.INSPECTION_INBOUND_ORDER]: [
          {
            prop: 'pickingBatchBizNo',
            label: '采摘批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'dryPeelBizNo',
            label: '干皮批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'recordTime',
            label: '干皮记录日期',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.parseTime(row.recordTime, '{y}-{m}-{d}')
            },
          },

          {
            prop: 'productName',
            label: '产品名称',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'specDetails',
            label: '规格',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'inventoryLocation',
            label: '仓库',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'storageArea',
            label: '库区',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'totalNetWeight',
            label: '干皮净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'unacceptedNetWeight',
            label: '不达标净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'status',
            label: '验收结果',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return isDef(row.status) ? row.status === 1 ? '达标' : '不达标' : '-'
            },
          },
          {
            prop: 'acceptedNetWeight',
            label: '可入库净重（斤）',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return row.status === 1 ? row.acceptedNetWeight : ''
            },
          },
        ],
        [TRACE_NAME.PRODUCT_INBOUND_DETAIL]: [
          {
            prop: 'pickingBatchBizNo',
            label: '采摘批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'dryBizNo',
            label: '干皮批次',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'recordTime',
            label: '入库日期',
            isTrue: true,
            minWidth: '150',
            formatter(row) {
              return _this.parseTime(row.recordTime, '{y}-{m}-{d}')
            },
          },

          {
            prop: 'productName',
            label: '产品名称',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'specDetails',
            label: '规格',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'inventoryLocation',
            label: '仓库',
            isTrue: true,
            minWidth: '150',
          },

          {
            prop: 'storageArea',
            label: '库区',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'storageLocName',
            label: '库位',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'storageTrayName',
            label: '托盘号',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'numberBox',
            label: '总筐数',
            isTrue: true,
            minWidth: '150',
          },
          {
            prop: 'quantity',
            label: '入库净重（斤）',
            isTrue: true,
            minWidth: '150',
          },
        ],
      }
      return colMap[this.currentName]
    },
  },
  watch: {
    data: {
      handler(form) {
        if (!form) return
        this.getTraceabilityNode(form)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getStepInfo(data) {
      if (data.name === TRACE_NAME.PICKING_BATCH_TASK) {
        return data.pickMap?.plantationName
      } else if (data.name === TRACE_NAME.SHIPPING_ORDER_ITEM) {
        return data.shippMap?.supplierName
      } else if (data.name === TRACE_NAME.INSPECTION_SHEET_ITEM) {
        return `工厂结算${data.inpectionMap?.totalSettlementNetWeight || '-'}斤`
      } else if (data.name === TRACE_NAME.FRESH_PEEL_PROD_REC) {
        return data.freshMap?.processFactory
      } else if (data.name === TRACE_NAME.DRY_PEEL_PROD_REC) {
        return data.dryMap?.peelRate ? `出皮率：${this.myFixed(data.dryMap?.peelRate, 2)}%` : ''
      } else if (data.name === TRACE_NAME.INSPECTION_INBOUND_ORDER) {
        return `可入库净重：${data.inboundMap?.acceptedNetWeight || '-'}斤`
      } else if (data.name === TRACE_NAME.PRODUCT_INBOUND_DETAIL) {
        return `${data.productInboundMap?.inventoryLocation}（仓库）`
      }
      console.log(1)
    },
    getTraceabilityNode({ bizNo, tenantId, dryBizNo }) {
      getTraceabilityNode({ bizNo, tenantId, dryBizNo }).then((res) => {
        if (res.flag && res.code === 200) {
          this.processList = res.data.map((item) => {
            item.bgColor = traceabilityStep[item.name].bgColor
            item.text = traceabilityStep[item.name].text
            return item
          })
        }
      })
    },
    closeDialog() {
      this.dialog = false
    },
    handleDetail(data, index) {
      this.currentPage = index + 1
      this.currentName = data.name

      this.formData = data
      this.formData.map = data[traceabilityStep[data.name]?.mapKey] || {}
      this.formData.map.recordTime = data.recordTime

      this.dialog = true

      this.$nextTick(() => {
        const body = document.querySelector('.trace-dialog').querySelector('.el-dialog__body')
        body.style.maxHeight = '70vh'
        body.style.height = '70vh'
      })
    },

    onCurrentChange(type) {
      if (type === 'prev') {
        if (this.currentPage > 1) {
          this.currentPage--
        }
      } else if (type === 'next') {
        if (this.currentPage < this.processList.length) {
          this.currentPage++
        }
      }
      const data = this.processList[this.currentPage - 1]
      this.formData = data
      this.formData.map = data[traceabilityStep[data.name]?.mapKey] || {}
      this.formData.map.recordTime = data.recordTime
      
      this.currentName = data.name
    },
  },
}
</script>

<style scoped lang="less">
@import '~@/assets/variables.less';
.container {
  display: flex;
  justify-content: center;
}

.steps {
  display: flex;
  flex-direction: column;
  height: 100%;

  .step:nth-child(odd) {
    flex-direction: row-reverse;
  }

  .step:nth-child(even) {
    .head {
      margin-left: 150px;
    }
  }

  .step:last-child {
    flex-basis: auto;
  }

  .step {
    display: flex;
    flex-basis: 150px;
    justify-content: flex-end;
    // flex-direction: row;
    // justify-content: start;
    // margin-bottom: 50px;

    .head {
      position: relative;
      box-sizing: border-box;
      .line {
        position: absolute;
        display: inline-block;
        width: 5px;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background-color: #ccc;
        z-index: 1;
      }
      .line:last-child {
        display: none;
      }
      .icon {
        position: relative;
        text-align: center;
        background-color: #fff;
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
      }
    }
    .main {
      width: 150px;
      box-sizing: border-box;
    }
  }
}

.m-steps {
  &_icon {
    box-sizing: border-box;
    display: inline-block;
    width: 70px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    color: #fff;
    box-shadow: 1px 5px 10px 0 #979797;
    border-radius: 50%;
    background-color: #cb921b;
  }

  &_content {
    text-decoration: underline;
    font-size: 14px;
    text-align: center;
    line-height: 70px;
    color: rgb(46, 107, 233);
    cursor: pointer;

    &_info {
      margin-top: 15px;
      p {
        line-height: normal;
        margin: 0;
      }
    }
  }
}

.title {
  margin-bottom: 30px;
  font-size: 18px;
  text-align: center;
}

.img {
  display: flex;
  flex-wrap: wrap;

  &-item {
    flex-basis: 50%;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;

    img {
      cursor: pointer;
      width: 100%;
      height: 100%;
    }

    &_slot {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  .left-button {
    // margin-right: 20px;
    color: #fff;
    background-color: @theme-color;
  }
  .right-button {
    color: #fff;
    background-color: @theme-color;
  }
  .page {
    margin: 0 50px;
    font-size: 18px;
  }
}
</style>
